import Const from 'constants';

const AllowOnlyOneDSTPositionPerLineup = {
    setAllowOnlyOneDSTPositionPerLineupFromStorage(value) {
        return (dispatch) => {
            dispatch(this.setAllowOnlyOneDSTPositionPerLineup(value, {saveToStorage: false}));
        };
    },

    setAllowOnlyOneDSTPositionPerLineup(value, options = {}) {
        return (dispatch) => {
            const {saveToStorage = true} = options;

            dispatch({
                type: Const.SET_ALLOW_ONLY_ONE_DST_POSITION_PER_LINEUP,
                allowOnlyOneDSTPositionPerLineup: Boolean(value),
            });

            saveToStorage && dispatch(
                this.saveDataToStorage('allowOnlyOneDSTPositionPerLineup', function (state) {
                    const {filters} = state.lineupsData;

                    return filters.allowOnlyOneDSTPositionPerLineup;
                }),
            );
        };
    },
};

export default AllowOnlyOneDSTPositionPerLineup;
